export class CustomParams {
  [key: string]: string | number | boolean;
}
